import React, {Suspense} from 'react'
import {BrowserRouter} from 'react-router-dom'
import {I18nProvider} from '../_metronic/i18n/i18nProvider'
import {LayoutProvider, LayoutSplashScreen} from '../_metronic/layout/core'
import AuthInit from '../setup/redux/auth/AuthInit'
import {Routes} from './routing/Routes'

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

type Props = {
  basename: string
}

const App: React.FC<Props> = ({basename}) => {
  React.useEffect(() => {
    const errorHandler = (e: any) => {
      if (e.message.includes("ResizeObserver loop completed with undelivered notifications") || e.message.includes("ResizeObserver loop limit exceeded")) {
        const resizeObserverErr = document.getElementById("webpack-dev-server-client-overlay");
        if (resizeObserverErr) {
          resizeObserverErr.style.display = "none";
        }
      }
    };
    window.addEventListener("error", errorHandler);
  
    return () => {
      window.removeEventListener("error", errorHandler);
    };
  }, []);
  

  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <BrowserRouter basename={basename}>
        <I18nProvider>
          <LayoutProvider>
            <AuthInit>
              <Routes />
            </AuthInit>
          </LayoutProvider>
        </I18nProvider>
      </BrowserRouter>
      <ToastContainer className="custom-toast" theme={'light'} autoClose={false} />
    </Suspense>
  )
}

export {App}
